import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
/* eslint-disable react/no-danger */
import * as React from 'react';
import { throttle } from 'es-toolkit/function';
import { styled, alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import NoSsr from '@mui/material/NoSsr';
import { Link } from '@mui/docs/Link';
import { useTranslate } from '@mui/docs/i18n';
import { samePageLinkNavigation } from 'docs/src/modules/components/MarkdownLinks';
import TableOfContentsBanner from 'docs/src/components/banner/TableOfContentsBanner';
import featureToggle from 'docs/src/featureToggle';
import DiamondSponsors from 'docs/src/modules/components/DiamondSponsors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Nav = styled('nav')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    top: 'var(--MuiDocs-header-height)',
    marginTop: 'var(--MuiDocs-header-height)',
    paddingLeft: 6,
    // Fix truncated focus outline style
    position: 'sticky',
    height: 'calc(100vh - var(--MuiDocs-header-height))',
    overflowY: 'auto',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(7),
    paddingRight: theme.spacing(4),
    // We can't use `padding` as @mui/stylis-plugin-rtl doesn't swap it
    display: 'none',
    scrollbarWidth: 'thin'
  }, theme.breakpoints.up('md'), {
    display: 'block'
  });
});
var NavLabel = styled(Typography)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    padding: theme.spacing(1, 0, 1, 1.4),
    fontSize: theme.typography.pxToRem(11),
    fontWeight: theme.typography.fontWeightSemiBold,
    textTransform: 'uppercase',
    letterSpacing: '.1rem',
    color: (theme.vars || theme).palette.text.tertiary
  };
});
var NavList = styled(Typography)({
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
var NavItem = styled(Link, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'active' && prop !== 'level';
  }
})(function (_ref4) {
  var theme = _ref4.theme;
  var activeStyles = {
    borderLeftColor: (theme.vars || theme).palette.primary[200],
    color: (theme.vars || theme).palette.primary[600],
    '&:hover': {
      borderLeftColor: (theme.vars || theme).palette.primary[600],
      color: (theme.vars || theme).palette.primary[600]
    }
  };
  var activeDarkStyles = {
    borderLeftColor: (theme.vars || theme).palette.primary[600],
    color: (theme.vars || theme).palette.primary[300],
    '&:hover': {
      borderLeftColor: (theme.vars || theme).palette.primary[400],
      color: (theme.vars || theme).palette.primary[400]
    }
  };
  return [{
    boxSizing: 'border-box',
    padding: '6px 0 6px 12px',
    borderLeft: "1px solid transparent",
    display: 'block',
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '&:hover': {
      borderLeftColor: (theme.vars || theme).palette.grey[400],
      color: (theme.vars || theme).palette.grey[600]
    },
    // TODO: We probably want `aria-current="location"` instead.
    variants: [{
      props: function props(_ref5) {
        var active = _ref5.active;
        return !!active;
      },
      style: [activeStyles, theme.applyDarkStyles(activeDarkStyles)]
    }, {
      props: function props(_ref6) {
        var active = _ref6.active;
        return !active;
      },
      style: [{
        color: (theme.vars || theme).palette.text.primary
      }, theme.applyDarkStyles({
        color: (theme.vars || theme).palette.grey[500]
      })]
    }, {
      props: function props(_ref7) {
        var level = _ref7.level;
        return level === 2;
      },
      style: {
        padding: "6px 0 6px ".concat(theme.spacing(3))
      }
    }, {
      props: function props(_ref8) {
        var level = _ref8.level;
        return level === 3;
      },
      style: {
        padding: "6px 0 6px ".concat(theme.spacing(4.5))
      }
    }],
    '&:active': activeStyles
  }, theme.applyDarkStyles({
    '&:hover': {
      borderLeftColor: (theme.vars || theme).palette.grey[500],
      color: (theme.vars || theme).palette.grey[200]
    },
    '&:active': activeDarkStyles
  })];
});
var noop = function noop() {};
function useThrottledOnScroll(callback, delay) {
  var throttledCallback = React.useMemo(function () {
    return callback ? throttle(callback, delay) : noop;
  }, [callback, delay]);
  React.useEffect(function () {
    if (throttledCallback === noop) {
      return undefined;
    }
    window.addEventListener('scroll', throttledCallback);
    return function () {
      window.removeEventListener('scroll', throttledCallback);
      throttledCallback.cancel();
    };
  }, [throttledCallback]);
}
function flatten(headings) {
  var itemsWithNode = [];
  headings.forEach(function (item) {
    itemsWithNode.push(item);
    if (item.children.length > 0) {
      item.children.forEach(function (subitem) {
        itemsWithNode.push(subitem);
      });
    }
  });
  return itemsWithNode;
}
function shouldShowJobAd() {
  var date = new Date();
  var timeZoneOffset = date.getTimezoneOffset();
  // Hide for time zones UT+5.5 - UTC+14 & UTC-8 - UTC-12
  if (timeZoneOffset <= -5.5 * 60 || timeZoneOffset >= 8 * 60) {
    return false;
  }
  return true;
}
var showJobAd = featureToggle.enable_job_banner && shouldShowJobAd();
export default function AppTableOfContents(props) {
  var toc = props.toc;
  var t = useTranslate();
  var items = React.useMemo(function () {
    return flatten(toc);
  }, [toc]);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeState = _React$useState2[0],
    setActiveState = _React$useState2[1];
  var clickedRef = React.useRef(false);
  var unsetClickedRef = React.useRef(null);
  var findActiveIndex = React.useCallback(function () {
    // Don't set the active index based on scroll if a link was just clicked
    if (clickedRef.current) {
      return;
    }
    var active;
    for (var i = items.length - 1; i >= 0; i -= 1) {
      // No hash if we're near the top of the page
      if (document.documentElement.scrollTop < 200) {
        active = {
          hash: null
        };
        break;
      }
      var item = items[i];
      var node = document.getElementById(item.hash);
      if (false) {
        if (!node) {
          console.error("Missing node on the item ".concat(JSON.stringify(item, null, 2)));
        }
      }
      if (node && node.offsetTop < document.documentElement.scrollTop + document.documentElement.clientHeight / 8) {
        active = item;
        break;
      }
    }
    if (active && activeState !== active.hash) {
      setActiveState(active.hash);
    }
  }, [activeState, items]);

  // Corresponds to 10 frames at 60 Hz
  useThrottledOnScroll(items.length > 0 ? findActiveIndex : null, 166);
  var handleClick = function handleClick(hash) {
    return function (event) {
      // Ignore click events meant for native link handling, for example open in new tab
      if (samePageLinkNavigation(event)) {
        return;
      }

      // Used to disable findActiveIndex if the page scrolls due to a click
      clickedRef.current = true;
      unsetClickedRef.current = setTimeout(function () {
        clickedRef.current = false;
      }, 1000);
      if (activeState !== hash) {
        setActiveState(hash);
      }
    };
  };
  React.useEffect(function () {
    return function () {
      clearTimeout(unsetClickedRef.current);
    };
  }, []);
  var itemLink = function itemLink(item, level) {
    return /*#__PURE__*/_jsx(NavItem, {
      display: "block",
      href: "#".concat(item.hash),
      underline: "none",
      onClick: handleClick(item.hash),
      active: activeState === item.hash,
      level: level,
      children: /*#__PURE__*/_jsx("span", {
        dangerouslySetInnerHTML: {
          __html: item.text
        }
      })
    });
  };
  if (false) itemLink.displayName = "itemLink";
  return /*#__PURE__*/_jsxs(Nav, {
    "aria-label": t('pageTOC'),
    children: [/*#__PURE__*/_jsx(NoSsr, {
      children: showJobAd && /*#__PURE__*/_jsxs(Link, {
        href: "https://jobs.ashbyhq.com/MUI?utm_source=2vOWXNv1PE",
        target: "_blank",
        sx: [function (theme) {
          return {
            mb: 2,
            p: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            backgroundColor: alpha(theme.palette.grey[50], 0.4),
            border: '1px solid',
            borderColor: (theme.vars || theme).palette.grey[200],
            borderRadius: 1,
            transitionProperty: 'all',
            transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDuration: '150ms',
            '&:hover, &:focus-visible': {
              borderColor: (theme.vars || theme).palette.primary[200]
            }
          };
        }, function (theme) {
          return theme.applyDarkStyles({
            backgroundColor: alpha(theme.palette.primary[900], 0.2),
            borderColor: (theme.vars || theme).palette.primaryDark[700],
            '&:hover, &:focus-visible': {
              borderColor: (theme.vars || theme).palette.primaryDark[500]
            }
          });
        }],
        children: [/*#__PURE__*/_jsx(Typography, {
          component: "span",
          variant: "button",
          sx: {
            fontWeight: '500',
            color: 'text.primary'
          },
          children: '🚀 Join the MUI team!'
        }), /*#__PURE__*/_jsx(Typography, {
          component: "span",
          variant: "caption",
          sx: {
            fontWeight: 'normal',
            color: 'text.secondary',
            mt: 0.5
          },
          children: "We're looking for React Engineers and other amazing roles－come find out more!"
        })]
      })
    }), toc.length > 0 ? /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(NavLabel, {
        children: t('tableOfContents')
      }), /*#__PURE__*/_jsx(NavList, {
        component: "ul",
        children: toc.map(function (item) {
          return /*#__PURE__*/_jsxs("li", {
            children: [itemLink(item, 1), item.children.length > 0 ? /*#__PURE__*/_jsx(NavList, {
              as: "ul",
              children: item.children.map(function (subitem) {
                var _subitem$children;
                return /*#__PURE__*/_jsxs("li", {
                  children: [itemLink(subitem, 2), ((_subitem$children = subitem.children) == null ? void 0 : _subitem$children.length) > 0 ? /*#__PURE__*/_jsx(NavList, {
                    as: "ul",
                    children: subitem.children.map(function (nestedSubItem) {
                      return /*#__PURE__*/_jsx("li", {
                        children: itemLink(nestedSubItem, 3)
                      }, nestedSubItem.text);
                    })
                  }) : null]
                }, subitem.text);
              })
            }) : null]
          }, item.text);
        })
      })]
    }) : null, /*#__PURE__*/_jsx(DiamondSponsors, {}), /*#__PURE__*/_jsx(TableOfContentsBanner, {})]
  });
}
false ? void 0 : void 0;